// Real pages from BASEBALL READY Volume 1 (WebP in Impultienda Recursos, store BASEBALL READY).
const R = 'https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/b00b4f6e-3cd1-43d0-85f7-43d01ab56338/';
export const PAGE_COVER = R + '1792797387853_bb-vol1-p01-cover-364ce2fa.webp';
export const pageSamples: Array<{
  src: string;
  label: string;
  title: string;
  text: string;
}> = [{
  src: PAGE_COVER,
  label: 'Volume 1 · Cover',
  title: 'Season Plan & 12 Ready-to-Run Practices',
  text: 'Four age groups – T-Ball 5–6, Coach Pitch 7–8, Kid Pitch 9–12 and Teens 13–14+ – with a 12-week season plan and 12 practices planned minute by minute.'
}, {
  src: R + '1792797391678_bb-vol1-p04-season-77390ba6.webp',
  label: 'Season plan · Page 4',
  title: 'Your Season at a Glance',
  text: '12 weeks in 3 phases – pre-season, regular season and playoffs – with 60, 75 and 90-minute practice blocks for every age group.'
}, {
  src: R + '1792797403141_bb-vol1-p09-stations-3784f9de.webp',
  label: 'Field diagram · Page 9',
  title: 'The 4-Station System',
  text: '12 players, 4 groups, 1 head coach and 2 parent helpers: where each station goes on the field, who runs it and how to rotate on the whistle.'
}, {
  src: R + '1792797395116_bb-vol1-p24-practice7-7b819687.webp',
  label: 'Practice 7 · Page 24',
  title: 'Kid Pitch (9–12) · 90 Minutes',
  text: 'Pitching, catching and line drives: goal, equipment list and a minute-by-minute plan from the welcome circle to the team huddle.'
}, {
  src: R + '1792797399130_bb-vol1-p25-script-2c02e1ca.webp',
  label: 'Practice 7 · Page 25',
  title: 'Coach Script & Stations',
  text: 'What to say to your players word for word, plus four drill cards with setup, timing and coach cues for each station.'
}, {
  src: R + '1792797406722_bb-vol1-p10-progression-eb1a7ac0.webp',
  label: 'Skill progression · Page 10',
  title: 'Skill Progression by Age',
  text: 'Catching, throwing, fielding, hitting, base running, pitching and game knowledge – what to expect at each of the 4 age groups.'
}, {
  src: R + '1792797410804_bb-vol1-p36-quiza-b4ce3061.webp',
  label: 'Coach Quiz A · Page 36',
  title: 'Coach Quiz A · Rules & Basics',
  text: '10 quick questions on rules, game situations and pitch counts – ready to print.'
}, {
  src: R + '1792797414313_bb-vol1-p38-answerkey-86ca731e.webp',
  label: 'Answer key · Page 38',
  title: 'Answer Key (Coach Copy)',
  text: 'Answers for Coach Quiz A and Quiz B, with pitch counts based on the public MLB Pitch Smart guidelines.'
}, {
  src: R + '1792797417750_bb-vol1-p39-evaluation-37da73e6.webp',
  label: 'Player evaluation · Page 39',
  title: 'Player Evaluation Matrix',
  text: 'Score every player from 1 to 4 on throwing, catching, fielding, hitting, running and effort in week 1, week 6 and week 12.'
}];
